<div *ngIf="user" class="mt-2">
  <div *ngIf="user" class="card shadow-sm">
    <div class="card-header" style="background-color: var(--accent-color) ;">
      <h2 style="color: white !important;">Benutzerdetails</h2>
    </div>
    <div class="card-body mt-3">
      <div class="row">
        <!-- Image Section -->
        <div class="col-md-4 d-flex align-items justify-content-center">
          <img *ngIf="user.image" [src]="user.image" alt="Benutzerbild" class="img-fluid rounded-circle" style="max-width: 200px; max-height: 200px;">
          <p *ngIf="!user.image" class="text-muted">Kein Bild verfügbar</p>
        </div>
        <!-- Details Section -->
        <div class="col-md-8">
          <ul class="list-group list-group-flush">
            <li class="list-group-item"><strong>ID:</strong> {{ user.id }}</li>
            <li class="list-group-item"><strong>Vollständiger Name:</strong> {{ user.fullName }}</li>
            <li class="list-group-item"><strong>E-Mail:</strong> {{ user.email }}</li>
            <li class="list-group-item"><strong>Rolle:</strong> {{ user.role }}</li>
            <li class="list-group-item"><strong>Konto gesperrt:</strong> {{ user.accountLocked ? 'Ja' : 'Nein' }}</li>
            <li class="list-group-item"><strong>Adresse:</strong> {{ user.address }}</li>
            <li class="list-group-item"><strong>Land:</strong> {{ user.country }}</li>
            <li class="list-group-item"><strong>Erstellt am:</strong> {{ user.createdAt?.toDate() | date:'medium' }}</li>
            <li class="list-group-item"><strong>Beruf:</strong> {{ user.job }}</li>
            <li class="list-group-item"><strong>Telefonnummer:</strong> {{ user.phoneCode }}{{ user.phoneNumber }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!user" class="container mt-5 text-center">
  <p class="text-muted">Benutzerdetails werden geladen...</p>
</div>